import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar6Colors = {
  background?: string;
  skin?: string;
  accessories?: string;
  hair?: string;
};

export const Avatar6 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar6Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar6" clipPath="url(#clip0_2286_5698)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="m179.54 254.226.199-16.079s.342-.016 1.067-.08v-.231c.51.04.996.048 1.489.08 2.119-.239 5.639-.709 10.903-1.665a9.336 9.336 0 0 0 1.107-.278c8.872-4.787 19.098-18.214 29.387-43.285 1.728-5.097 3.202-11.101 3.592-17.528-2.692-21.83-4.317-46.032-4.317-54.243 0-14.423-10.464-25.7-20.897-30.438-7.231-3.29-14.694-13.874-18.588-20.054h-.757c2.023 5.36 4.452 14.28 1.33 20.523-4.738 9.486-50.738 46-58.806 52.165-2.572 1.967-4.611 9.158-6.251 19.352a32.107 32.107 0 0 0-1.721-3.791c-3.496-6.538-6.968-12.065-11.89-13.674a9.69 9.69 0 0 0-2.166-.438h-.04a8.586 8.586 0 0 0-1.115-.024h-.04a11.974 11.974 0 0 0-1.274.12c-.35.055-.709.127-1.075.215l-.207.047c-.398.104-.804.223-1.219.367l-.127.048c-.366.127-.74.278-1.115.446-.111.047-.215.095-.326.143-.43.191-.86.398-1.307.637-6.626 3.544-7.573 14.709-2.102 24.943.303.566.613 1.107.94 1.641.024.048.055.087.08.135.31.51.636.996.97 1.473.049.064.089.128.136.192.327.462.661.907 1.012 1.346.055.063.103.135.159.199.343.43.7.836 1.06 1.234.055.064.11.119.166.183a25.31 25.31 0 0 0 1.267 1.29c.39.375.78.725 1.186 1.068.032.023.064.055.096.079a22.817 22.817 0 0 0 2.644 1.912 20.477 20.477 0 0 0 1.41.788 17.318 17.318 0 0 0 1.409.637c.43.175.86.327 1.29.454.032.008.072.024.104.032.43.127.868.231 1.298.318.024 0 .056.008.08.016.438.08.876.144 1.314.176h.024c1.346.095 2.652-.048 3.87-.454a9.45 9.45 0 0 0 1.402-.598 8.498 8.498 0 0 0 1.378-.931c-1.872 20.069.613 44.717-3.632 64.277-1.481 6.801-3.488 12.543-5.853 17.393v.016c.963-.398 1.935-.78 2.914-1.155 25.389-9.564 49.863-10.807 69.884-8.959-.103-.008-.207-.024-.31-.032l-.032-.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M180.599 238.474c-26.998-1.999-47.832-21.798-59.316-45.674 1.975 33.401 21.583 80.357 58.105 85.796-.159-9.66.749-28.551 1.211-40.122Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_2"
          d="M142.659 136.343s11.516-2.946 21.248-2.755c11.436.223 19.241 7.757 23.637 1.266.757-1.107-1.879-6.674-22.817-8.203-13.276-.972-15.736 2.835-22.068 9.692Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M224.019 131.445c-17.736-.597-22.936 9.9-21.447 11.731.924 1.131 2.915 1.075 4.579-.477 4.954-3.313 5.679-3.377 17.131-3.775.167-1.426-.119-6.316-.263-7.479Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M202.572 143.177c-.271-.335-.326-.932-.095-1.665-9.366 18.524 5.574 34.03 1.337 38.498-2.954 3.122-18.476-1.441-17.473 3.942.693 3.258 20.603 4.444 23.614-2.883 1.091-3.727-11.309-27.197-2.804-38.378-1.672 1.553-3.655 1.609-4.579.478v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="accessories"
          d="M75.459 283.072c22.434 13.085 48.525 20.587 76.375 20.587 30.135 0 58.216-8.776 81.837-23.916-2.58-7.016-5.765-13.929-5.765-13.929s-56.306-25.827-117.931-2.604c-12.527 4.722-24.067 11.715-34.508 19.862h-.008Z"
          fill={c.accessories}
        />
        <Path
          id="Vector_5"
          d="M155.226 284.41c-15.116 1.393-31.37 6.14-46.422 13.053a150.805 150.805 0 0 0 27.436 5.399c16.804-6.036 26.759-5.041 30.78.04a150.78 150.78 0 0 0 40.665-9.851c-14.368-5.535-32.979-10.441-52.459-8.641Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <G id="Group">
          <Path
            id="Vector_6"
            d="M220.714 287.15c.112-.056.215-.112.319-.168-.112.056-.215.112-.327.168h.008Z"
            fill="#1A191A"
          />
          <Path
            id="Vector_7"
            d="M82.81 287.349s.016 0 .024-.008c-.757-.383-1.505-.773-2.246-1.171.74.39 1.473.796 2.23 1.179h-.008Z"
            fill="#1A191A"
          />
          <Path
            id="hair"
            d="M240.178 223.302c.876-9.182 12.679-25.787 12.679-41.962 0-16.175-14.423-29.722-13.985-42.838.438-13.117.438-47.649-13.555-59.451-13.992-11.803-32.787-28.416-51.144-26.226-18.357 2.19-28.041-9.039-61.243 3.839-17.864 6.928-41.915 45.554-43.667 71.349-1.752 25.788 1.314 38.466-5.248 51.145-4.157 8.044-34.317 30.749-37.956 58.264a152.573 152.573 0 0 0 49.13 45.769c9.62-7.502 20.18-14.032 31.585-18.699 0 0 0-.016.008-.024 2.365-4.85 4.372-10.592 5.853-17.393 4.253-19.56 1.76-44.216 3.632-64.278-.43.343-.884.669-1.378.932a9.45 9.45 0 0 1-1.402.598c-1.226.406-2.524.549-3.87.453h-.024c-.43-.031-.868-.087-1.314-.175-.024 0-.048-.008-.08-.016a13.32 13.32 0 0 1-1.298-.318c-.032-.008-.072-.024-.104-.032a14.069 14.069 0 0 1-1.393-.494 15.751 15.751 0 0 1-1.386-.637 20.034 20.034 0 0 1-1.33-.749s-.008 0-.016-.008a22.687 22.687 0 0 1-2.628-1.903c-.032-.024-.064-.056-.096-.08a23.69 23.69 0 0 1-1.186-1.067 2.662 2.662 0 0 0-.151-.143 30.499 30.499 0 0 1-1.115-1.147c-.056-.064-.112-.119-.168-.183a39.486 39.486 0 0 1-1.059-1.235c-.056-.063-.104-.135-.16-.199a34.732 34.732 0 0 1-1.01-1.346c-.048-.063-.088-.127-.136-.191a31.3 31.3 0 0 1-.972-1.473c-.023-.048-.055-.088-.08-.135a30.1 30.1 0 0 1-.939-1.641c-5.471-10.234-4.524-21.399 2.103-24.943.445-.239.876-.446 1.306-.637.111-.048.223-.096.326-.144.382-.167.757-.31 1.115-.446.04-.016.088-.031.127-.047.415-.144.82-.263 1.219-.367.072-.016.143-.032.207-.048a14.74 14.74 0 0 1 1.075-.215.532.532 0 0 0 .104-.015c.398-.056.788-.088 1.17-.104h.04c.382-.008.749 0 1.115.024h.04a9.69 9.69 0 0 1 2.166.438c4.922 1.609 8.402 7.136 11.89 13.674a32.63 32.63 0 0 1 1.721 3.791c1.632-10.186 3.671-17.377 6.251-19.353 8.06-6.164 54.06-42.679 58.806-52.164 3.122-6.243.693-15.155-1.33-20.523h.757c3.894 6.18 11.357 16.764 18.588 20.053 10.433 4.739 20.897 16.016 20.897 30.439 0 8.211 1.625 32.421 4.317 54.243-.39 6.434-1.856 12.431-3.592 17.528-10.297 25.071-20.523 38.498-29.387 43.284a9.342 9.342 0 0 1-1.107.279c-5.264.956-8.784 1.434-10.903 1.665-.493-.024-.979-.04-1.481-.08v.231c-.733.064-1.075.08-1.075.08l-.199 16.079c.103.008.207.024.31.032 28.575 2.636 48.047 11.563 48.047 11.563s3.186 6.905 5.766 13.914a152.3 152.3 0 0 0 17.561-13.125c.063-.351.111-.693.151-1.019.876-7.869-11.803-33.218-10.927-42.401l.032.008Z"
            fill={c.hair}
          />
        </G>
        <G id="Group_2" fill="#000">
          <Path
            id="Vector_8"
            d="M180.647 150.352c-.845-.685-1.641-1.362-2.421-2.023-4.468-3.791-8.681-7.358-15.562-6.984-.916.048-1.808.151-2.676.295-4.189.358-8.402 1.784-12.01 3.472-1.282.661-1.688 2.365-.828 3.528a2.389 2.389 0 0 0 3.345.534 19.752 19.752 0 0 1 1.593-1.012 32.298 32.298 0 0 1 3.838-1.903c-.055.35-.087.701-.087 1.067a7.201 7.201 0 0 0 7.199 7.199c3.974 0 7.2-3.225 7.2-7.199a6.8 6.8 0 0 0-.088-1.075c2.023 1.139 3.91 2.731 6.005 4.507.796.677 1.617 1.37 2.469 2.063.294.239.653.358 1.003.358.462 0 .924-.199 1.235-.589a1.585 1.585 0 0 0-.231-2.238h.016Z"
          />
          <Path
            id="Vector_9"
            d="M226.273 149.078c-.908-.359-8.96-3.457-12.671-3.234-4.42.263-6.459 2.302-7.948 3.791a22.36 22.36 0 0 1-.446.438 1.597 1.597 0 0 0-.04 2.254c.239.247.534.398.836.454a5.972 5.972 0 0 0 11.851-1.059c0-.765-.16-1.489-.423-2.166 2.836.701 6.173 1.895 7.678 2.484a1.588 1.588 0 0 0 2.062-.899 1.59 1.59 0 0 0-.899-2.063Z"
          />
        </G>
        <Path
          id="Vector_10"
          d="M170.947 200.454c.932.669 15.705 13.905 29.093 12.097 11.404-1.537 12.559-13.881 12.782-14.479 0 0-4.086-3.679-7.59-3.201-3.504.47-5.79 2.461-5.79 2.461s-4.794-2.294-8.521-1.792c-3.719.502-6.857 2.787-10.297 3.719-3.481.94-9.677 1.195-9.677 1.195Zm5.026 1.561c-.072-.088 0 0 .111.031 4.428 1.131 11.747-.159 23.207-1.712 5.901-.796 10.019.247 13.165-1.155-2.509 3.457-6.093 6.626-11.994 7.423-11.492 1.553-20.603.263-24.489-4.587Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5698">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
